import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, MapPinIcon, PhoneIcon, MailIcon, ClockIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-neutral-dark text-white pt-20 pb-10 px-4" data-id="element-62">
      <div className="max-w-7xl mx-auto" data-id="element-63">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-64">
          {/* Brand Col */}
          <div className="col-span-2 lg:col-span-1" data-id="element-65">
            <div className="mb-6" data-id="element-66">
              <div className="inline-block bg-white/5 p-2 rounded-full backdrop-blur-sm border border-white/10" data-id="element-67">
                <img src="https://cdn.magicpatterns.com/uploads/bw7AM2ZxN5rndR2BD9QGFb/Gemini_Generated_Image_e872g4e872g4e872-removebg-preview.png" alt="Ambient Solutions LLC — A Tailored Path to Optimal Health" className="h-24 w-auto brightness-110 contrast-110" data-id="element-68" />
              </div>
            </div>
            <p className="text-white/70 mb-6 text-sm leading-relaxed" data-id="element-69">
              Ambient Solutions LLC — A Tailored Path to Optimal Health. We help
              families hire, train, and certify their own loved ones as
              professional caregivers, backed by skilled nursing oversight.
            </p>
            <div className="flex items-center gap-4" data-id="element-70">
              <a href="#" className="text-white/70 hover:text-accent transition-colors" aria-label="Facebook" data-id="element-71">
                <FacebookIcon className="w-5 h-5" data-id="element-72" />
              </a>
              <a href="#" className="text-white/70 hover:text-accent transition-colors" aria-label="Twitter" data-id="element-73">
                <TwitterIcon className="w-5 h-5" data-id="element-74" />
              </a>
              <a href="#" className="text-white/70 hover:text-accent transition-colors" aria-label="Instagram" data-id="element-75">
                <InstagramIcon className="w-5 h-5" data-id="element-76" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-77">
            <h3 className="font-heading font-bold text-lg mb-6 text-accent" data-id="element-78">
              Quick Links
            </h3>
            <ul className="space-y-4" data-id="element-79">
              <li data-id="element-80">
                <Link to="/" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-81">
                  Home
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/about" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-83">
                  About Us
                </Link>
              </li>
              <li data-id="element-84">
                <Link to="/services" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-85">
                  Services
                </Link>
              </li>
              <li data-id="element-86">
                <Link to="/how-it-works" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-87">
                  How It Works
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/contact" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-89">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-90">
            <h3 className="font-heading font-bold text-lg mb-6 text-accent" data-id="element-91">
              Our Services
            </h3>
            <ul className="space-y-4" data-id="element-92">
              <li data-id="element-93">
                <Link to="/services" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-94">
                  Skilled Nursing
                </Link>
              </li>
              <li data-id="element-95">
                <Link to="/services" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-96">
                  Personal Care
                </Link>
              </li>
              <li data-id="element-97">
                <Link to="/services" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-98">
                  Companion Care
                </Link>
              </li>
              <li data-id="element-99">
                <Link to="/services" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-100">
                  Alzheimer's/Dementia
                </Link>
              </li>
              <li data-id="element-101">
                <Link to="/services" className="text-white/70 hover:text-accent transition-colors text-sm" data-id="element-102">
                  Respite Care
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-103">
            <h3 className="font-heading font-bold text-lg mb-6 text-accent" data-id="element-104">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-105">
              <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-106">
                <MapPinIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-107" />
                <span data-id="element-108">
                  10632 Little Patuxent Parkway
                  <br data-id="element-109" />
                  Columbia, MD 21044
                </span>
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm" data-id="element-110">
                <PhoneIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-111" />
                <a href="tel:+18666528987" className="hover:text-accent transition-colors" data-id="element-112">
                  (866) 652-8987
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm" data-id="element-113">
                <MailIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-114" />
                <a href="mailto:info@ambienthomecare.com" className="hover:text-accent transition-colors" data-id="element-115">
                  info@ambienthomecare.com
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-116">
                <ClockIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-117" />
                <span data-id="element-118">
                  Mon - Fri: 8:00 AM - 6:00 PM
                  <br data-id="element-119" />
                  Sat - Sun: Closed
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-120">
          <p className="text-white/50 text-sm" data-id="element-121">
            &copy; 2026 Ambient Solutions LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-white/50" data-id="element-122">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-123">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-124">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}